import React from 'react';
import styled from 'styled-components';

import Banner from '../../components/Telephone/Banner';
import Calculation from '../../components/Telephone/Calculation';
import ConnectSection from '../../components/Telephone/ConnectSection';
import Services from '../../components/Telephone/Services';
import Tariffs from '../../components/Telephone/Tariffs';

const Content = styled.div`
    position: relative;
    width: 100%;
`;

interface IProps {
    tariffsData: object,
}

export const Telephone = ({ tariffsData } : IProps) => {
    const title = 'Подключите домашний телефон';

    return (
        <Content>
            <Banner
                title={title}
                text='Экономьте на междугородних звонках. Бесплатно подключайте к обычному телефону определитель
                номера, режим «Не беспокоить», переадресацию и даже будильник.'
                image='/static/images/telephone/bg-1.png'
            />
            <Tariffs
                title='Добавьте к тарифу, чтобы экономить на звонках'
                tariffData={tariffsData}
            />
            <Calculation
                title='Сколько будет стоить звонок в другой регион или страну?'
                text='Звоните без переплат. Калькулятор минут рассчитает и покажет стоимость звонка.'
            />
            <Services
              title='А эти услуги можно подключить бесплатно'
            />
            <ConnectSection
                title='Подключить домашний телефон'
            />
        </Content>
    );
};
